import { WebsiteDisplayItem } from '../api/WebsiteDisplayItem';
import { WebsiteInputItem } from '../api/WebsiteInputItem';
import { WebsitePageDisplayItem } from '../api/WebsitePageDisplayItem';
import { WebsiteScriptCodeDisplayItem } from '../api/WebsiteScriptCodeDisplayItem';
import { WebsiteUpdateItem } from '../api/WebsiteUpdateItem';

declare module '../api/WebsiteDisplayItem' {
    namespace WebsiteDisplayItem {
        let ConvertToInputItem: typeof convertToInputItem;
        let ConvertToUpdateItem: typeof convertToUpdateItem;
    }

    export interface WebsiteDisplayItem {
        ViewedPageID: string   // Only used for undo tree
    }
}

WebsiteDisplayItem.ConvertToInputItem = convertToInputItem;
WebsiteDisplayItem.ConvertToUpdateItem = convertToUpdateItem;

function convertToInputItem(displayItem: WebsiteDisplayItem): WebsiteInputItem {
    return new WebsiteInputItem({
        Url: displayItem.Url,
        Title: displayItem.Title,
        AccentColor: displayItem.AccentColor,
        BackgroundColor: displayItem.BackgroundColor,
        HeaderColor: displayItem.HeaderColor,
        FooterColor: displayItem.FooterColor,
        HeadingFontFamily: displayItem.HeadingFontFamily,
        BodyFontFamily: displayItem.BodyFontFamily,
        ScriptCodes: displayItem.ScriptCodes.map(WebsiteScriptCodeDisplayItem.ConvertToInputItem),
        SocialLinksLocation: displayItem.SocialLinksLocation,
        HeaderLogoMediaLibraryItemID: displayItem.HeaderLogoMediaLibraryItemID,
        Template: displayItem.Template,
        HostingType: displayItem.HostingType,

        WebsitePages: displayItem.WebsitePages?.map(WebsitePageDisplayItem.ConvertToInputItem),
    });
}

function convertToUpdateItem(displayItem: WebsiteDisplayItem, includePages: boolean = false): WebsiteUpdateItem {
    return new WebsiteUpdateItem({
        // We want use partial updates here so if their external custom domain no longer is valid, they can still make changes to their website
        Url: undefined,
        Title: displayItem.Title,
        AccentColor: displayItem.AccentColor,
        BackgroundColor: displayItem.BackgroundColor,
        HeaderColor: displayItem.HeaderColor,
        FooterColor: displayItem.FooterColor,
        HeadingFontFamily: displayItem.HeadingFontFamily,
        BodyFontFamily: displayItem.BodyFontFamily,
        ScriptCodes: displayItem.ScriptCodes.map(WebsiteScriptCodeDisplayItem.ConvertToInputItem),
        SocialLinksLocation: displayItem.SocialLinksLocation,
        HeaderLogoMediaLibraryItemID: displayItem.HeaderLogoMediaLibraryItemID,
        Template: displayItem.Template,
        HostingType: displayItem.HostingType,

        WebsitePages: includePages ? displayItem.WebsitePages?.map(WebsitePageDisplayItem.ConvertToInputItem) ?? [] : undefined,
    });
}
